<div fxLayout="column" class="page-container">
  <div fxLayout="column" class="eon-backdrop" fxLayoutAlign="center center">
    <div class="content-container" fxLayoutAlign="center center" fxLayout="column">
      <h1 class="splash-headline" fxLayoutAlign="center center">Question Configuration</h1>

      <eon-ui-button text="Add new question" (click)="createQuestion()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>

      <div class="table-container">
        <table mat-table matSort [dataSource]="dataSource">
          <ng-container matColumnDef="questionId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let question">{{question.questionId}}</td>
          </ng-container>

          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>question</th>
            <td mat-cell *matCellDef="let question">{{question.question}}</td>
          </ng-container>

          <ng-container matColumnDef="correct_answer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>answer</th>
            <td mat-cell *matCellDef="let question">{{question.correct_answer}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>actions</th>
            <td mat-cell *matCellDef="let question" fxLayoutGap="2px" fxLayout="row">
              <eon-ui-button icon="trash_bin" size="small" (click)="deleteQuestion(question)"></eon-ui-button>
              <eon-ui-button icon="edit" size="small" (click)="editQuestion(question)"></eon-ui-button>
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

    </div>
  </div>
</div>
